import { render, staticRenderFns } from "./GravarObservacaoDialog.vue?vue&type=template&id=2ca85be7&"
import script from "./GravarObservacaoDialog.vue?vue&type=script&lang=js&"
export * from "./GravarObservacaoDialog.vue?vue&type=script&lang=js&"
import style0 from "./GravarObservacaoDialog.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports